export default "__VITE_ASSET__r0NeJ0aM__"